module.exports = __webpack_public_path__ + "img/alp-duran-SwMgX1d0Kmw-unsplash.7b479376.jpg";